import locSaintJulien from "@/assets/loc-saint-julien.jpg";
import locContis from "@/assets/loc-contis.jpg";
import locVielle from "@/assets/loc-vielle.jpg";
import locPinsDor from "@/assets/loc-pins-dor.jpg";
import locLousSeurrots from "@/assets/loc-lous-seurrots.png";
import locSenYan from "@/assets/loc-sen-yan.jpg";
import locSoleilLandes from "@/assets/loc-soleil-landes.jpg";

export interface Location {
  name: string;
  slug: string;
  address: string;
  city: string;
  postalCode: string;
  lat: number;
  lng: number;
  phone: string;
  image: string;
  bookingUrl: string;
  description: string;
  type: "village" | "camping";
}

export const locations: Location[] = [
  {
    name: "Saint-Julien-en-Born",
    slug: "saint-julien-en-born",
    address: "208 Rte des Lacs",
    city: "Saint-Julien-en-Born",
    postalCode: "40170",
    lat: 44.0685,
    lng: -1.2355,
    phone: "05 58 42 75 12",
    image: locSaintJulien,
    bookingUrl: "https://ebikeandco.lokki.rent/",
    description: "Notre point de location principal, idéalement situé au cœur du village de Saint-Julien-en-Born, à deux pas de la piste cyclable menant à l'océan.",
    type: "village",
  },
  {
    name: "Contis Plage",
    slug: "contis-plage",
    address: "27 Bd de la Plage",
    city: "Saint-Julien-en-Born",
    postalCode: "40170",
    lat: 44.0890,
    lng: -1.3185,
    phone: "05 58 42 75 12",
    image: locContis,
    bookingUrl: "https://ebikeandco-contis.lokki.rent/",
    description: "Directement sur le front de mer de Contis, récupérez votre vélo et partez explorer la côte landaise sans attendre.",
    type: "village",
  },
  {
    name: "Vielle-Saint-Girons",
    slug: "vielle-saint-girons",
    address: "43 Rue Cante Coucut",
    city: "Vielle-Saint-Girons",
    postalCode: "40560",
    lat: 43.9410,
    lng: -1.3050,
    phone: "07 49 73 25 32",
    image: locVielle,
    bookingUrl: "https://ebikeandco.lokki.rent/",
    description: "Au cœur de Vielle-Saint-Girons, entre lac et océan, un point de départ parfait pour vos balades à vélo dans les Landes.",
    type: "village",
  },
  {
    name: "Camping Les Pins d'Or",
    slug: "camping-les-pins-dor",
    address: "40 Rte de Lespecier",
    city: "Bias",
    postalCode: "40170",
    lat: 44.1580,
    lng: -1.2050,
    phone: "09 78 81 84 52",
    image: locPinsDor,
    bookingUrl: "https://ebikeandco.lokki.rent/",
    description: "Directement installés au sein du Camping Les Pins d'Or à Bias, nous livrons vos vélos à votre emplacement.",
    type: "camping",
  },
  {
    name: "Camping Lous Seurrots",
    slug: "camping-lous-seurrots",
    address: "606 Av. de l'Océan",
    city: "Saint-Julien-en-Born",
    postalCode: "40170",
    lat: 44.0890,
    lng: -1.3165,
    phone: "07 49 73 25 32",
    image: locLousSeurrots,
    bookingUrl: "https://ebikeandco-lous-seurrots.lokki.rent/",
    description: "Partenaire du Camping Lous Seurrots, nous assurons la location de vélos directement sur place pour vos vacances.",
    type: "camping",
  },
  {
    name: "Camping Sen Yan",
    slug: "camping-sen-yan",
    address: "Av. de la Gare",
    city: "Mézos",
    postalCode: "40170",
    lat: 44.0830,
    lng: -1.1630,
    phone: "09 78 81 84 52",
    image: locSenYan,
    bookingUrl: "https://ebikeandco.lokki.rent/",
    description: "Au Camping Sen Yan à Mézos, profitez de nos vélos pour explorer les environs et rejoindre les pistes cyclables landaises.",
    type: "camping",
  },
  {
    name: "Le Soleil des Landes",
    slug: "le-soleil-des-landes",
    address: "316 Route du Marensin",
    city: "Lit-et-Mixe",
    postalCode: "40170",
    lat: 44.0345,
    lng: -1.2555,
    phone: "05 58 42 75 12",
    image: locSoleilLandes,
    bookingUrl: "https://ebikeandco-litetmixe.lokki.rent/",
    description: "Au camping Le Soleil des Landes à Lit-et-Mixe, profitez de nos vélos pour explorer les pistes cyclables et la côte landaise.",
    type: "camping",
  },
];
